// Custom adjustments for ADA compliance
(function ($, Drupal, drupalSettings) {
  'use strict';

    Drupal.behaviors.dlaADAChosen = {
      attach: function(context, settings) {
        $('body').on('chosen:ready', function(evt, params) {
          $('.js-form-item.js-form-type-select', context).each(function(index, element) {
            $(this).find('.chosen-container-multi input.chosen-search-input').attr('aria-label', $.trim($(this).find('label').text()));
          });
        });
      }
    }

})(jQuery, Drupal, drupalSettings);
